import apiCall from '../utils/api';
import ApiPath from '../constants/api';
import API from '../constants/common';
import { AxiosResponse } from 'axios';

type GetNotificationsCountResponse = {
  count: number;
};

export const getNotificationsCount = () => {
  return apiCall(ApiPath.notificationsCount, API.METHOD.GET, {
    is_read: false
  }) as Promise<AxiosResponse<GetNotificationsCountResponse>>;
};

export type NotificationListItem = {
  id: string;
  title: string;
  message: string;
  webLink: string;
  readReceipt: boolean;
  type: string;
  createdAt: string;
  updatedAt: string;
};

export type NotificationsListResponse = {
  items: NotificationListItem[];
  total_items: number;
  next_page: boolean;
};

type GetNotificationsListPayload = {
  size?: number;
  page?: number;
  sort_order?: string;
  is_read?: boolean;
};

export const getNotificationsList = (
  {
    size = 10,
    page = 0,
    sort_order = 'descending',
    is_read
  }: GetNotificationsListPayload,
  signal?: AbortSignal
) => {
  const params: GetNotificationsListPayload = {
    size,
    page,
    sort_order
  };
  if (is_read === false) params.is_read = false;
  return apiCall(
    ApiPath.notifications,
    API.METHOD.GET,
    params,
    false,
    signal
  ) as Promise<AxiosResponse<NotificationsListResponse>>;
};

export const markReadNotfications = (notificationIds: string[]) => {
  return apiCall(ApiPath.notificationsMarkRead, API.METHOD.POST, {
    notificationIds
  }) as Promise<AxiosResponse<unknown>>;
};
